import { useQuery, useMutation } from "react-query";
import NotificationService from "../../../services/NotificationService";

const useSearchNotification = (onSuccess, onError, params, isFetchData) => {
  return useQuery(["NOTIFICATION", params], () => getNotification(params), {
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: Infinity,
    //staleTime: 0,
    cacheTime: 0,
    enabled: true,
    // refetchInterval: 10000,
  });
};

// - Search
const getNotification = (params) => {
  return NotificationService.getNotification(params);
};

export { useSearchNotification };
